import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Briefcase, Scale, Gavel, Users, Building2, Landmark, ShieldCheck, ShoppingBag, Home, Laptop, Leaf, Stethoscope, ChevronRight } from 'lucide-react';
import { CATEGORIES } from '../mock/mock';
import { metaApi } from '../api/client';
import SEO from '../components/SEO';

const ICON_MAP = { Briefcase, Scale, Gavel, Users, Building2, Landmark, ShieldCheck, ShoppingBag, Home, Laptop, Leaf, Stethoscope };

export default function Categories() {
  const [countByCat, setCountByCat] = useState({});
  useEffect(() => {
    metaApi.categories().then(list => setCountByCat(Object.fromEntries(list.map(c => [c.slug, c.count])))).catch(() => {});
  }, []);

  return (
    <div>
      <SEO title="Áreas do direito" description="Explore escritórios especializados em Direito Trabalhista, Cível, Criminal, Família, Empresarial, Tributário e outras áreas jurídicas." />
      <div className="bg-white border-b border-[#cbd8dc] text-[#122f36]">
        <div className="aj-wrap py-14">
          <nav className="text-xs text-[#52676e] mb-4">
            <Link to="/" className="hover:text-[#063f4c]">Início</Link> / Áreas do Direito
          </nav>
          <h1 className="text-3xl md:text-4xl font-semibold">Áreas do direito</h1>
          <p className="text-[#354c54] mt-2 max-w-2xl">Explore escritórios especializados em cada área de atuação jurídica.</p>
        </div>
      </div>

      <div className="aj-wrap py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {CATEGORIES.map(cat => {
            const Icon = ICON_MAP[cat.icon] || Scale;
            return (
              <Link key={cat.slug} to={`/categoria/${cat.slug}`} className="group bg-white border border-[#cbd8dc] rounded-[10px] p-6 hover:border-[#547a83] hover:border-[#547a83] transition-all flex items-start gap-4">
                <div className="w-12 h-12 rounded-[7px] bg-[#f2f6f7] group-hover:bg-[#153e44] flex items-center justify-center transition-colors shrink-0">
                  <Icon className="w-6 h-6 text-[#153e44] group-hover:text-[#075a6d] transition-colors" />
                </div>
                <div className="flex-1">
                  <h3 className="font-semibold text-[#153e44] group-hover:text-[#075a6d] transition-colors">{cat.name}</h3>
                  <p className="text-sm text-[#52676e] mt-1">{countByCat[cat.slug] ?? "—"} {countByCat[cat.slug] === 1 ? 'escritório especializado' : 'escritórios especializados'}</p>
                </div>
                <ChevronRight className="w-5 h-5 text-[#6b858e] group-hover:text-[#075a6d] group-hover:translate-x-1 transition-all" />
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
}
